<template>
  <div>
    <img v-if="geomType === 'raster'" src="@/assets/images/geom/raster-icon.png">
    <img v-if="geomType === 'point'" src="@/assets/images/geom/point-icon.png">
    <img v-if="geomType === 'line'" src="@/assets/images/geom/line-icon.png">
    <img v-if="geomType === 'polygon'" src="@/assets/images/geom/polygon-icon.png">
  </div>
</template>

<script>
export default {
  name: 'GeomTypeIcon',
  props: {
    geomType: {
      type: String,
      default: () => { return 'point' }
    }
  }
}
</script>

<style>

</style>